import { categories, categoryImages } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              Shop by Category
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-md">
              Browse our complete collection of international shopping categories, each organized for easy discovery and management.
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200"
          >
            View All on Main Site &rarr;
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden h-48 md:h-56 cursor-pointer"
            >
              <img
                src={categoryImages[cat.name]}
                alt={`${cat.name} - Superbuy Spreadsheet category`}
                title={`${cat.name} - Superbuy Spreadsheet`}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent"></div>

              <div className="absolute top-3 right-3">
                <span className="px-2.5 py-1 bg-white/90 backdrop-blur-sm text-foreground-800 text-[10px] md:text-xs font-semibold rounded-md whitespace-nowrap">
                  {cat.name.split(' / ')[0].toUpperCase()}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <h3 className="text-white font-semibold text-sm md:text-base">{cat.name}</h3>
                <p className="text-white/60 text-xs mt-1">Shop Now &rarr;</p>
              </div>
            </a>
          ))}
        </div>

        <div className="flex justify-center mt-10 gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <span>Explore All Categories</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}